import { getCoreUtils } from "./kCoreHandler";

/** UTF-8 size without allocating encoded bytes or requiring TextEncoder/Buffer. */
export class kUtf8TextCore {
    public static ByteLength = (Text: string): number => {
        if (getCoreUtils().KErrorMode) { return 0; }
        try {
            let Bytes: number = 0;
            for (let I: number = 0; I < Text.length; I++) {
                const Code: number = Text.charCodeAt(I);
                if (Code < 0x80) { Bytes += 1; }
                else if (Code < 0x800) { Bytes += 2; }
                else if (kUtf8TextCore.IsPairedHighSurrogate(Text, I)) { Bytes += 4; I++; }
                else { Bytes += 3; }
            }
            return Bytes;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "kUtf8TextCore.ByteLength");
            return 0;
        }
    };

    public static IsPairedHighSurrogate = (Text: string, At: number): boolean => {
        if (getCoreUtils().KErrorMode) { return false; }
        try {
            const Code: number = Text.charCodeAt(At);
            if (Code < 0xD800 || Code > 0xDBFF || At + 1 >= Text.length) { return false; }
            const Next: number = Text.charCodeAt(At + 1);
            return Next >= 0xDC00 && Next <= 0xDFFF;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "kUtf8TextCore.IsPairedHighSurrogate");
            return false;
        }
    };
}
